import { Injectable } from '@angular/core';
import { SITE_ANALYTICS_PAGE_DEFINITIONS } from '@client/app/feature-modules/site-analytics/definitions/site-analytics-page-definitions';
import type {
    SiteAnalyticsDataSourceKey,
    SiteAnalyticsScaffoldConfig,
} from '@client/app/feature-modules/site-analytics/types/site-analytics-page-scaffold.type';

@Injectable({
    providedIn: 'root',
})
export class SiteAnalyticsScaffoldConfigService {
    getConfig (dataSource: SiteAnalyticsDataSourceKey): SiteAnalyticsScaffoldConfig {
        return SITE_ANALYTICS_PAGE_DEFINITIONS[dataSource].config;
    }
}
